<ion-list class="ion-hide-md-down">
  <ion-menu-toggle autoHide="false">
    <ion-item
      button
      routerLink="/tabs/dashboard"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/dashboard_24dp.svg"
        slot="start"
      ></ion-icon>
      <ion-label>Dashboard</ion-label>
    </ion-item>
  </ion-menu-toggle>
  @if (canUploadFreights()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/tabs/freight-ship-pending"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/okc_upload_freights_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.pending' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>

    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/tabs/freight-ship-inprogress"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/okc_shipper_inprogress_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.in_progress' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>

    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/tabs/freight-ship-finished"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/okc_shipper_finished_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.finished' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
</ion-list>

<ion-list>
  @if (canCreateDeca()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        [routerLink]="DECA_ROUTES.NEW"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/qr_code_2_add_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.create_deca' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
  @if (canViewDeca()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        [routerLink]="DECA_ROUTES.LIST"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/qr_code_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.view_deca' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
</ion-list>

<ion-list>
  @if (canAdministrativeDocuments()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/my-company"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/domain_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'company.my_company' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>

    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/billing-shipper"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/payments_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.billing' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }

  @if (canCrudUsers()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/users"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/group_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.users' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
  @if (canUploadFreights()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/sustainability"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/potted_plant_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>Sostenibilidad</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
</ion-list>

<ion-list>
  <ion-menu-toggle autoHide="false">
    <ion-item
      button
      routerLink="/account"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/account_circle_24dp.svg"
        slot="start"
      ></ion-icon>
      <ion-label>{{ 'general.nav_bar.account' | translate }}</ion-label>
    </ion-item>
  </ion-menu-toggle>
</ion-list>
